import Icon from '../components/Icon.vue'

Icon.register({
  robot: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M32 224h32v192h-32 0c-17.6 0-32-14.3-32-32 0 0 0 0 0 0v-128 0c0-17.6 14.3-32 32-32 0 0 0 0 0 0zM544 176v272c0 35.3-28.7 64-64 64h-320c-35.3 0-64-28.7-64-64v-272 0c0-44.1 35.8-80 80-80 0 0 0 0 0 0h112v-64c0-17.7 14.3-32 32-32s32 14.3 32 32v64h112 0c44.1 0 80 35.8 80 80 0 0 0 0 0 0zM264 256c0-22.1-17.9-40-40-40s-40 17.9-40 40 17.9 40 40 40c22.1 0 40-17.9 40-40zM256 384h-64v32h64v-32zM352 384h-64v32h64v-32zM456 256c0-22.1-17.9-40-40-40s-40 17.9-40 40 17.9 40 40 40c22.1 0 40-17.9 40-40zM448 384h-64v32h64v-32zM640 256v128 0c0 17.6-14.3 32-32 32 0 0 0 0 0 0h-32v-192h32 0c17.6 0 32 14.3 32 32 0 0 0 0 0 0z'
      }
    ]
  }
})
